module.exports = __webpack_public_path__ + "static/img/yingxiao.66ab81a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/service/yingxiao.png
// module id = M6CQ
// module chunks = 4